/**
 * shared/possession-proof.ts — the one place the server and the client agree on
 * how "prove you still hold the authenticator" is spelled on the wire.
 *
 * Shared for the same reason as `shared/session-death-codes.ts`: the server
 * EMITS this code (`server/middleware/zero-trust/possession.ts`) and the client
 * MATCHES on it to run the heartbeat and retry the original request
 * (`client/src/lib/session-possession.ts`). Two independent string literals is
 * the shape where one side is renamed and the other silently stops matching —
 * and the failure here is not a broken screen but a gated read that starts
 * surfacing a raw 403 to the user with no way to satisfy it.
 *
 * NOT a session-death code. The session is alive; `isSessionDeathCode` must
 * never admit this value, or the client would wipe a live vault KEK on what is
 * an ordinary step-up prompt.
 */

/** 403 code: the session needs a fresh WebAuthn possession proof to continue. */
export const POSSESSION_PROOF_REQUIRED = "POSSESSION_PROOF_REQUIRED" as const;

/** Endpoints of the heartbeat ceremony, shared so the two halves cannot drift. */
export const POSSESSION_PROOF_BEGIN_PATH = "/api/auth/webauthn/possession/begin" as const;
export const POSSESSION_PROOF_COMPLETE_PATH = "/api/auth/webauthn/possession/complete" as const;
